<form [formRoot]="contact.form">

  <div [formFieldControl]="contact.form.name">
    <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
    <label>Name<span class="text-warn">*</span></label>
    <input type="text" [formField]="contact.form.name">
    @for (error of contact.form.name().errors(); track error.kind) {
    <span class="error">{{error | errorMessage}}</span>
    }
  </div>

  <div [formFieldControl]="contact.form.email">
    <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
    <label>Email</label>
    <input type="email" [formField]="contact.form.email">
    @for (error of contact.form.email().errors(); track error.kind) {
    <span class="error">{{error | errorMessage}}</span>
    }
  </div>

  <div [formFieldControl]="contact.form.phoneNumber">
    <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
    <label>Phone Number</label>
    <phone-number-input [controls]="contact.form.phoneNumber"></phone-number-input>
    @for (error of contact.form.phoneNumber().errorSummary(); track error.kind) {
    <span class="error">{{error | errorMessage}}</span>
    }
  </div>

  <div [formFieldControl]="contact.form.subject">
    <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
    <label>Subject<span class="text-warn">*</span></label>
    <input type="text" [formField]="contact.form.subject">
    @for (error of contact.form.subject().errors(); track error.kind) {
    <span class="error">{{error | errorMessage}}</span>
    }
  </div>

  <div [formFieldControl]="contact.form.message">
    <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
    <label>Message</label>
    <div class="field field-interactive">
      <textarea [formField]="contact.form.message" class="resize-none" rows="5"></textarea>
    </div>
    @for (error of contact.form.message().errors(); track error.kind) {
    <span class="error">{{error | errorMessage}}</span>
    }
  </div>

  <div class="mt-4 flex gap-4">
    <button type="submit"
            class="btn btn-flat"
            mat-ripple
            [disabled]="loading.any$()">
      <replace-spinner [showSpinner]="contact.submitting()">
        Send message
      </replace-spinner>
    </button>
  </div>
</form>
